import React from 'react';
import Gallery from 'react-photo-gallery';
// import storyPhoto from '../img/wigs_comp.jpg'

// import FontAwesomeIcon from '@fortawesome/react-fontawesome'
// import angleDown from '@fortawesome/fontawesome-free-solid/faAngleDown'
// import angleUp from '@fortawesome/fontawesome-free-solid/faAngleUp'

import WithAnimation from './WithAnimation'

class Photos extends WithAnimation {
  constructor(props) {
    super(props);

    this.state = {
      photos: []
    }
  }

  addPhotos() {
    const photos = this.props.place && this.props.place.photos,
      allPhotos = [];

    for (var i = 0; i < photos.length; i++) {
      let photo = photos[i]

      allPhotos.push({
        src: photo.getUrl(),
        width: photo.width,
        height: photo.height
      })
    }

    this.setState({ photos: allPhotos })
  }

  componentDidUpdate(prevProps) {
    if (this.props.place !== prevProps.place) this.addPhotos();
  }

  componentDidMount() {
    if (this.props.place && this.props.place.photos) this.addPhotos();

  }

  render() {
    const { photos } = this.state;
    return (
      <div className="photos">
        <h3>Photos</h3>
        <Gallery photos={photos} />
      </div>
    );
  }
}

export default Photos;



// WEBPACK FOOTER //
// ./src/components/Photos.jsx